import { TransferBaseModel } from '../transfer-base.model';

export interface Platform {
    id?: string;
    order?: string;
    friendly_name?: string;
    min_amount?: number;
    max_amount?: number;
    enabled?: boolean;
    tenants_linked?: ObjectLink[];
    tenants_unlink?: ObjectLink[];
    gateways_linked?: GatewayLink[];
    gateways_unlink?: ObjectLink[];
}

export enum AccountTypes {
    Basic = 'Basic',
    Silver = 'Silver',
    Gold = 'Gold',
    Platinum = 'Platinum'
}

export interface ObjectLink {
    id?: string;
}

export interface GatewayLink extends ObjectLink {
    priority?: number;
    risk_level_lookup?: string;
    register_date_before?: Date;
    register_date_after?: Date;
}

export interface AvailablePlatform extends TransferBaseModel {
    id?: string;
    code?: string;
    account_type: string[];
    currency: string[];
    default_currency: string;
    name?: string;
}
